import apiConfig from './APIConfig';

const baseURL = apiConfig.appConfig.apictms;

export default baseURL;
